import BillingPeriod from './BillingPeriod';

class BillingPeriodSet {
  private static readonly MONTHS_IN_YEAR = 12;
  private static readonly OFFSET_MONTHS = 1;
  private readonly billingPeriods: BillingPeriod[];

  constructor(start: Date) {
    this.billingPeriods = [];
    this.generateBillingPeriods(start);
  }

  getBillingPeriods = () => {
    return this.billingPeriods;
  };

  getBillingPeriodByIndex = (index: number): BillingPeriod => {
    if (index < 0 || index >= this.billingPeriods.length) {
      throw new Error('Invalid index');
    }
    return this.billingPeriods[index];
  };

  private generateBillingPeriods = (startDate: Date) => {
    for (let i = 0; i < BillingPeriodSet.MONTHS_IN_YEAR; i++) {
      const periodStart = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
      const billingPeriod = new BillingPeriod(
        periodStart,
        BillingPeriodSet.MONTHS_IN_YEAR,
        BillingPeriodSet.OFFSET_MONTHS
      );
      this.billingPeriods.push(billingPeriod);
    }
  };
}

export default BillingPeriodSet;
